import { useState, useEffect, useRef } from "react";
import phoneEmojie from "../assets/icons/phoneEmojie.png";
import cardEmojie from "../assets/icons/cardEmojie.png";
import greenCircleEmojie from "../assets/icons/greenCircleEmojie.png";
import receiptEmojie from "../assets/icons/receiptEmojie.png";
import blankEmojie from "../assets/icons/blankEmojie.png";
import bankEmojie from "../assets/icons/bankEmojie.png";
import userEmojie from "../assets/icons/userEmojie.png";
import RendersDropdownItem from "./RendersDropdownItem";

const RendersDropdown = ({
  text,
  listMenu,
  setSelectedItem,
  selectedItem,
  disabled,
  openDropdown,
  setOpenDropdown,
  dropdownName,
}) => {
  const isOpen = openDropdown === dropdownName;
  const textRef = useRef(null);
  const containerRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    if (textRef.current && containerRef.current) {
      setIsOverflowing(textRef.current.scrollWidth > containerRef.current.clientWidth);
    }
  }, [selectedItem, isOpen, textRef, containerRef]);

  const toggleMenu = () => {
    if (disabled) return;
    setOpenDropdown(isOpen ? null : dropdownName);
  };

  const getIcon = (type) => {
    switch (type) {
      case "📱":
        return phoneEmojie;
      case "💳":
        return cardEmojie;
      case "🟢":
        return greenCircleEmojie;
      case "🧾":
        return receiptEmojie;
      case "📄":
        return blankEmojie;
      case "🏦":
        return bankEmojie;
      case "👤":
        return userEmojie;
      default:
        return blankEmojie;
    }
  };

  const handleItemSelect = (item) => {
    setSelectedItem(item);
    setOpenDropdown(null);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".input")) {
        setOpenDropdown(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [setOpenDropdown]);

  return (
    <>
      <div
        className={`input flex justify-between py-5 px-6 items-center cursor-pointer select-none text-[#B7B7B7] bg-white rounded-sm ${
          disabled ? "opacity-50" : ""
        }`}
        onClick={toggleMenu}
      >
        <span className="truncate text-[#0B1F24] flex items-center gap-4 font-secondaryTitle text-2xl">
          {selectedItem ? (
            <div className="flex gap-2 items-center max-w-full">
              <div className="input__icon">
                <img
                  className="w-[30px] max-w-[30px] min-w-[30px]"
                  src={getIcon(selectedItem.emojie)}
                  alt="icon"
                />
              </div>
              <h3 className="font-secondaryTitle text-2xl flex items-center flex-nowrap">
                {selectedItem.type}
              </h3>
              <div
                ref={containerRef}
                className="w-full overflow-hidden whitespace-nowrap relative items-center flex"
              >
                <p
                  ref={textRef}
                  className={`font-body text-[#6C6C6C] text-sm inline-block ${
                    isOverflowing ? "animate-marquee" : ""
                  }`}
                >
                  {selectedItem.name}
                </p>
              </div>
            </div>
          ) : (
            text
          )}
        </span>
        <svg
          width="14"
          height="9"
          viewBox="0 0 14 9"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={isOpen ? "rotate" : ""}
        >
          <path
            d="M7.75593 8.12713C7.35716 8.58759 6.64284 8.58759 6.24407 8.12713L0.638744 1.65465C0.0778678 1.00701 0.53792 -5.55611e-07 1.39467 -6.3051e-07L12.6053 -1.61058e-06C13.4621 -1.68548e-06 13.9221 1.00701 13.3613 1.65465L7.75593 8.12713Z"
            fill="#5F6260"
          />
        </svg>
      </div>
      <ul
        className={`input__submenu absolute hidden left-[67px] right-0 list-none mt-2 p-0 bg-[#F2F2F2] border-solid border border-[#ccc] rounded-sm z-10 ${
          isOpen ? "show" : ""
        }`}
      >
        {listMenu &&
          listMenu.map((item, index) => (
            <RendersDropdownItem
              item={item}
              index={index}
              key={index}
              getIcon={getIcon}
              handleItemSelect={handleItemSelect}
              isOpen={isOpen}
            />
          ))}
      </ul>
    </>
  );
};

export default RendersDropdown;
